import { AfterViewChecked, ChangeDetectorRef, Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { DivisionDataMappingFormService } from './division-data-mapping-form.service';
import { SaveGuardStore } from '@r1-compass-library/guards/save-guard.store';
import { FormUnsavedChangesWarningDivisionSettings } from '@r1-compass-library/guards/hasUnsavedChanges.guard';
import { FieldMappingMapperComponent } from './field-mapping-mapper/field-mapping-mapper.component';
import { SaveDivisionSettingsFooterComponent } from '../save-footer.component';

@Component({
    selector: 'r1-compass-app-division-data-mapping',
    imports: [
        MatInputModule,
        ReactiveFormsModule,
        MatSelectModule,
        MatButtonModule,
        FieldMappingMapperComponent,
        MatExpansionModule,
        SaveDivisionSettingsFooterComponent,
    ],
    template: `
        <form [formGroup]="formService.divisionDataMappingForm" (ngSubmit)="onSave()">
            <section id="mappers">
                <r1-compass-app-field-mapping-mapper />
            </section>

            <r1-compass-app-save-division-settings-footer [disabled]="!formService.divisionDataMappingForm.valid" />
        </form>
    `,
    providers: [DivisionDataMappingFormService],
})
export class DivisionDataMappingComponent implements AfterViewChecked, FormUnsavedChangesWarningDivisionSettings {
    readonly #cdr = inject(ChangeDetectorRef);
    protected readonly formService = inject(DivisionDataMappingFormService);
    readonly #formSaveWarningStore = inject(SaveGuardStore);

    canDeactivate$ = this.#formSaveWarningStore.deriveCanDeactivate$(this.formService.divisionDataMappingForm);
    saveGuardHandlerFn = this.#formSaveWarningStore.formUnsavedChangesWarningDivisionSettings;

    constructor() {
        this.saveGuardHandlerFn({
            form: this.formService.divisionDataMappingForm,
            canDeactivate$: this.canDeactivate$,
        });
    }

    ngAfterViewChecked(): void {
        this.#cdr.detectChanges();
    }

    public onSave() {
        // [disabled]="!formService.divisionDataMappingForm.valid"
        return this.formService.submit();
    }
}
